import { useRef } from 'react';

import { Image, Text } from '@change/ds-core-ui';

import redLine from 'src/assets/memberships/red-line.svg';

import type { Props } from '../../shared/types';
import { AmountSelectorSunrise } from '../AmountSelectorSunrise';

import { useMembershipAwarenessPlacementConfig } from './hooks/useMembershipAwarenessPlacementConfig';
import { useTracking } from './hooks/useTracking';

export function MembershipAwarenessSunrise({ sourceLocation, slug, signed }: Props): React.JSX.Element {
	const element = useRef<HTMLElement>(null);
	const {
		data: { headlinePart1, headlinePart2, body, ctaQuestion, heroImage },
	} = useMembershipAwarenessPlacementConfig();
	useTracking({ sourceLocation, element });

	return (
		<div className="flex flex-col gap-4 rounded-medium bg-gradient-background-light-2 pt-3.5 elevation-low md:pt-4">
			<Image src={heroImage} alt="main onsite image" className="max-h-[100px] w-full object-cover md:block" />
			<div className="flex flex-col gap-6 p-6 md:flex-row md:gap-10">
				<div className="flex h-full flex-1 flex-col gap-6 text-typography-strong md:gap-4">
					<div className="flex flex-col text-typography-strong">
						<Image alt="" src={redLine} width="35" height="20" />
						<Text variant="heading" size="large">
							{headlinePart1}
						</Text>
						<Text variant="heading" size="x-small">
							{headlinePart2}
						</Text>
					</div>
					<div className="flex flex-col gap-4">
						<Text>{body}</Text>
						<Text fontWeight="bold">{ctaQuestion}</Text>
					</div>
				</div>
				<div className="align-center flex-1">
					<AmountSelectorSunrise sourceLocation={sourceLocation} slug={slug} signed={signed} />
				</div>
			</div>
		</div>
	);
}
